import { render, staticRenderFns } from "./detailRelevancyReq.vue?vue&type=template&id=fce5f892&scoped=true&"
import script from "./detailRelevancyReq.vue?vue&type=script&lang=js&"
export * from "./detailRelevancyReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce5f892",
  null
  
)

export default component.exports